import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Row, Col, Panel, Form, InputGroup, Modal } from 'react-bootstrap';
import FormField from './FormField';
import AutoComplete from './AutoComplete';
import { TEMPLATES_CARDS } from '../TemplatesForm';
import ConfirmDialog from './ConfirmDialog';
import StaticField from './StaticField';
import TextInput from './TextInput';
import Button from './Button';
import Table from './Table';
import { sendFaxAction,
         faxStatusAction,
         caseSetServerError,
         caseFilesLoadAction } from '../../actions/caseActions';

import { userDownloadFile,
         userBuyFaxCreditAction } from '../../actions/userActions';

import { retrieveNotifications,
         getStripeAdjustedPrice,
         extractFieldsOptions, 
         getDownloadPath } from '../../helpers/utils';

import { dialogHeaderFooterBgColor } from '../../helpers/colors';
import TemplatesSelect from './TemplatesSelect';

export const commonFields = ['FaxCompletedAt', 'FaxStatus', 'TemplateName', 'Recipient', 'FaxNo', 'FaxRequestedAt', 'FaxPagesNo', 'FaxId', 'SenderId'];
export const commonFieldsLabels = ['Completed At', 'Status', 'Document', 'Recipient', 'Fax Number', 'Sent At', 'Pages', 'Fax Id', 'Sender Id'];

class FaxForm extends PureComponent {
    constructor(props) {
        super(props);
        this.sendFax = this.sendFax.bind(this);
        this.refreshFaxStatuses = this.refreshFaxStatuses.bind(this);
        this.downloadFaxRow = this.downloadFaxRow.bind(this);
        this.paymentDialogConfirm = this.paymentDialogConfirm.bind(this);
        this.preventValueArrayChange = false;
        this.addValueArray = this.addValueArray.bind(this);
        this.onEditValueArray = this.onEditValueArray.bind(this);
        this.deleteValueArray = this.deleteValueArray.bind(this);
        this.validateFaxes = this.validateFaxes.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.state = {
            loading: false,
            buyingCredits: false,
            buyPagesValue: 0,
            paymentDialogOpen: false,
            faxes: [{}],
            faxesErrors: [],
        };
    }

    componentDidMount() {
        const currentCase = this.props.currentCase;
        if (currentCase && 
            currentCase.id &&
            !currentCase._loadingFaxes) {

            this.refreshFaxStatuses(currentCase.id);
        }

        if (currentCase && !currentCase.files && !currentCase._loadingAllEvents && !currentCase._loadingFiles && currentCase.id) {
            this.props.dispatch(caseFilesLoadAction(currentCase.id))
                .then((result) => {
                    if (!result) {
                        this.props.dispatch(caseSetServerError('Cannot load uploaded files - networking error?'));
                        return;
                    }

                })
                .catch((error) => {
                    this.props.dispatch(caseSetServerError(error));
                });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentCase && !nextProps.currentCase.files && !nextProps.currentCase._loadingFiles && nextProps.currentCase.id) {
            nextProps.dispatch(caseFilesLoadAction(nextProps.currentCase.id))
                .then((result) => {
                    if (!result) {
                        nextProps.dispatch(caseSetServerError('Cannot load uploaded files - networking error?'));
                        return;
                    }

                })
                .catch((error) => {
                    nextProps.dispatch(caseSetServerError(error));
                });
        }

        if (nextProps.currentCase && 
            nextProps.currentCase.id &&
            !nextProps.currentCase.faxesPoll &&
            !nextProps.currentCase._loadingFaxes) {

            this.refreshFaxStatuses(nextProps.currentCase.id);
        }
    }

    downloadFile(attachment) {
        this.props.dispatch(userDownloadFile(attachment['$DownloadPath$']));
    }

    downloadFaxRow(rowIndex, currentFax) {
        let templateType = 'fax';
        let templateName = 'FaxConfirmationSheet.docx';
        let fields = {};
        for (let property in currentFax.field) {
            if (currentFax.field.hasOwnProperty(property)) {
                fields[`docs.currentFax.${property}`] = currentFax.field[property];
            }
        }

        let extraVariables = encodeURIComponent(JSON.stringify(fields));
        let downloadPath = `/api/v1/download/default_template/${templateType}/${templateName}?extraVariables=${extraVariables}`;
        this.props.dispatch(userDownloadFile(downloadPath));
    }

    refreshFaxStatuses(id) {
        if (!id &&
            this.props.currentCase &&
            this.props.currentCase.id) {

            id = this.props.currentCase.id;
        }

        if (!id) {
            this.setState({
               loading: false
            });

            return;
        }

        this.setState({
            loading: true
        });

        this.props.dispatch(faxStatusAction(id))
           .then((result) => {
                this.setState({
                   loading: false
                });

                retrieveNotifications(this.props.dispatch);
           })
           .catch((error) => {
               console.error(new Error().stack, error);
               this.setState({
                   loading: false
               });

               this.props.dispatch(caseSetServerError(error));
           });
    }

    paymentDialogConfirm() {
        let amount = parseInt(this.state.buyPagesValue, 10);
        if (isNaN(amount) || amount <= 0) {
            this.props.dispatch(caseSetServerError('Please provide a positive whole number.'));
            return;
        }

        if (amount < process.env.FAX_PAGES_ORDER_MINIMUM_MOUNT) {
            this.props.dispatch(caseSetServerError(`Minimum number of ordered faxing pages is ${process.env.FAX_PAGES_ORDER_MINIMUM_MOUNT}.`));
            return;
        }

        this.setState({
            buyingCredits: true,
            paymentDialogOpen: false
        });

        this.props.dispatch(userBuyFaxCreditAction(amount))
            .then((result) => {
                if (!result) {
                    this.props.dispatch(caseSetServerError('Error while trying to buy credits.'));
                }

                this.setState({
                    buyingCredits: false
                });
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.setState({
                    buyingCredits: false
                });

                this.props.dispatch(caseSetServerError(error));
            });
    }

    validateFaxes() {
        let faxesErrors = [];
        let error = false;
        if (!this.props.recipients) {
            return;
        }

        for (let i = 0; i < this.state.faxes.length; i++) {
            let fax = this.state.faxes[i];
            faxesErrors.push({});
            let faxErrors = faxesErrors[i];
            if (!fax.recipient) {
                error = true;
                faxErrors.recipientError = 'Recipient must be specified';
            }

            if (!fax.attachment || !_.isObject(fax.attachment)) {
                let error = true;
                faxErrors.attachmentError = 'Select valid attachment';
            }

            if (faxErrors.recipientError && !faxErrors.attachmentError) {
                faxErrors.attachmentError = '!';
            }

            if (!faxErrors.recipientError && faxErrors.attachmentError) {
                faxErrors.recipientError = '!';
            }
        }

        if (!_.isEqual(faxesErrors, this.state.faxesErrors)) {
            this.setState({faxesErrors});
        }

        return !error;
    }

    sendFax(evt) {
        evt.preventDefault();
        if (this.state.loading || !this.validateFaxes()) {
            return;
        }

        let faxes = this.state.faxes;
        let faxObjects = [];
        for (let i = 0; i < faxes.length; i++) {
            let fax = faxes[i];
            let faxObject = {...fax.attachment};
            if (_.isString(fax.recipient)) {
                let faxOption = this.props.recipients.find(v => {
                    return v.label === fax.recipient;
                });

                if (faxOption) {
                    faxObject['Recipient'] = faxOption.label;
                    faxObject['FaxNo'] = faxOption.value;

                } else {
                    faxObject['FaxNo'] = fax.recipient;
                }

            } else {
                faxObject['Recipient'] = fax.recipient.label;
                faxObject['FaxNo'] = fax.recipient.value;
            }

            faxObjects.push(faxObject);
        }

        if (faxObjects.length === 0) {
            return;
        }

        this.setState({ loading: true });
        const sendFaxDispatch = () => {
            this.props.dispatch(sendFaxAction(faxObjects))
                .then((result) => {
                    if (result) {
                        this.refreshFaxStatuses();
                        this.setState({ loading: false, faxes: [{}], faxesErrors: [] });
                        if (this.props.dialogCancel) {
                            this.props.dialogCancel();
                        }
                    } else {
                        this.setState({ loading: false });
                    }
                })
                .catch((error) => {
                    console.error(new Error().stack, error);
                    this.setState({
                       loading: false
                    });

                    this.props.dispatch(caseSetServerError(error));
                });
        };

        if (this.props.beforeFaxSending) {
            this.props.beforeFaxSending(faxObjects)
                .then((result) => {
                    if (result) {
                        sendFaxDispatch();

                    } else {
                        this.setState({
                            loading: false
                        });
                    }
                });

        } else {
            sendFaxDispatch();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.validateFaxes();
    }


    addValueArray(index) {
        let faxes = _.cloneDeep(this.state.faxes);
        faxes.splice(index + 1, 0, {});

        // Changing the state causes render to rerender components,
        // causing onEditValueArray to fire. Disable such updates until the state has
        // been successfully modified.
        this.preventValueArrayChange = true;
        this.setState({faxes}, () => {
            this.preventValueArrayChange = false;
            this.validateFaxes();
        });
    }

    onEditValueArray(index, entryName, value) {
        if (this.preventValueArrayChange) {
            return;
        }

        let faxes = _.cloneDeep(this.state.faxes);
        faxes[index][entryName] = value;
        this.setState({faxes}, () => {
            this.validateFaxes();
        });
    }

    deleteValueArray(index) {
        let faxes = _.cloneDeep(this.state.faxes);
        faxes.splice(index, 1);
        if (faxes.length == 0) {
            faxes.push({recipient: '', attachment: ''});
        }

        this.preventValueArrayChange = true;
        this.setState({faxes}, () => {
            this.preventValueArrayChange = false;
            this.validateFaxes();
        });
    }

    render() {
        const {
            help,
            disabled,
            loading,
            config,
            loggedIn,
            showAsDialog,
            dialogOpen,
            disableCaseFilesAutoload,
            renderFaxesSentComponent
        } = this.props;

        const dialogCancel = () => {
            this.setState({ faxes: [{}], faxesErrors: [] });
            if (this.props.dialogCancel) {
                this.props.dialogCancel();
            }
        }
        
        let pagesLeft = 0;
        if (this.props.billing) {
            pagesLeft = Math.floor(this.props.billing.FaxCredit / process.env.CENTS_PER_FAX_PAGE);
        }

        let isLoading = this.state.loading || this.state.downloading;
        let buyPagesCost = '---';
        if (this.state.buyPagesValue > 0) {
            buyPagesCost = getStripeAdjustedPrice(process.env.CENTS_PER_FAX_PAGE * this.state.buyPagesValue);
            if (!buyPagesCost || buyPagesCost <= 0) {
                buyPagesCost = '---';

            } else {
                buyPagesCost /= 100.0;
                buyPagesCost = buyPagesCost.toFixed(2);
            }
        }

        const sendFaxesBtn = (
            <Button bsStyle="primary"
                    label="Fax All Jobs"
                    icon="send"
                    loading={isLoading}
                    disabled={(pagesLeft <= 0) ||
                                disabled ||
                                isLoading}
                    loadingLabel="Processing ..."
                    onClick={this.sendFax}
                    tooltip="Send fax from selected templates to selected recipients"/>
        );

        let result = (
            <div>
                {showAsDialog && (
                <div>
                <Row>
                    <Col xs={2} style={{marginBottom: 15, textAlign: 'center'}}>
                        <h6><b>Pages Left: {pagesLeft}</b></h6>
                    </Col>
                    {loggedIn && loggedIn.owner_id === 0 && (
                    <Col xs={6} md={4}>
                        <Button style={{width: 150}}
                                label="Buy Pages ..."
                                icon="credit-card"
                                loading={this.state.buyingCredits}
                                disabled={this.state.buyingCredits}
                                loadingLabel="Processing ..."
                                onClick={() => {this.setState({paymentDialogOpen: true})}}
                                closed={() => this.setState({buyingCredits: false})}
                                tooltip="Buy pages for faxing"/>
                    </Col>)}
                </Row>
                {this.state.faxes.map((fax, index) => {
                    return (
                        <div>
                        <Panel data-hj-whitelist header={`Fax Job ${index + 1}`}>
                        <Form>
                        <Row>
                        <Col xs={12}>
                        <TemplatesSelect
                            field={{
                                name: 'attachment' + index,
                                error: this.state.faxesErrors.length > index && this.state.faxesErrors[index].attachmentError,
                                touched: true,
                                value: fax.attachment && fax.attachment['Label'],
                                onChange: fileName => { 
                                    if (!fileName) {
                                        this.onEditValueArray(index, 'attachment', '');
                                        return;
                                    }

                                    const convertToAttachment = (name, type, downloadPath) => {
                                        return {
                                            'label': name,
                                            'value': name,
                                            'Label': name,
                                            'FileName': name,
                                            'CaseId': this.props.currentCase.id,
                                            'UploadType': type,
                                            '$DownloadPath$': downloadPath
                                        };
                                    };

                                    let downloadPath = '';
                                    let type = 'notes';
                                    if (_.isObject(fileName)) {
                                        downloadPath = fileName['$DownloadPath$'];
                                        type = fileName['$Subfolder$'];
                                        fileName = fileName['Name'];
                                    } else {
                                        downloadPath = getDownloadPath(name, this.props.currentCase.id, type);
                                    }
                                
                                    const attachment = convertToAttachment(fileName, type, downloadPath);
                                    this.onEditValueArray(index, 'attachment', attachment);
                            }}}
                            uploadDocTemplateOnSelect
                            label="Attachments"
                            enabledDocuments={TEMPLATES_CARDS.filter(v => v.value === 'documents' || v.value === 'doc_templates')}
                            valueComponent={option => 
                                <Button
                                    style={{ height: 18, marginTop: -20, zIndex: 1000 }}
                                    label={option.label}
                                    bsStyle="link"
                                    onClick={(evt) => {
                                        evt.preventDefault();
                                        this.downloadFile(option);
                                    }}
                                />}
                        />
                        </Col>
                        </Row>
                        <Row>
                        <Col xs={12}>
                        <AutoComplete field={{
                                          name: 'recipient' + index,
                                          error: this.state.faxesErrors.length > index && this.state.faxesErrors[index].recipientError,
                                          touched: true,
                                          value: fax.recipient && fax.recipient.label,
                                          onChange: (value) => {
                                               this.onEditValueArray(index, 'recipient', value);
                                          }
                                      }}
                                      options={this.props.recipients}
                                      returnSelectedObject
                                      allowNew
                                      label='Fax To'/>
                        </Col>
                        </Row>
                        </Form>
                        </Panel>
                        <Row>
                        <Col xs={3} md={2}>
                        <InputGroup style={{marginTop: '-15px', marginBottom: '15px'}}>
                            <InputGroup.Button>
                            <Button onClick={() => this.deleteValueArray(index)}
                                    block
                                    icon="trash"
                                    tooltip="Remove fax job"/>
                            </InputGroup.Button>
                            <InputGroup.Button>
                            <Button onClick={() => this.addValueArray(index)}
                                    block
                                    icon="plus"
                                    tooltip="Add fax job"/>
                            </InputGroup.Button>
                        </InputGroup>
                        </Col>
                        </Row>
                        </div>);
                })}
                <div style={{ paddingBottom: 250 }} />
                <ConfirmDialog title='Buy Faxing Credit'
                               text={`Specify how many pages you want to buy.\nThe cost is $${process.env.CENTS_PER_FAX_PAGE / 100.0} per page. Credit card processing fee will be (${(process.env.STRIPE_PERCENT_CHARGE * 100.0).toFixed(2)}% + ${process.env.STRIPE_FIXED_CHARGE_CENTS}c) and appropriate sales tax will be added on top`}
                               cancel={() => this.setState({ paymentDialogOpen: false })}
                               confirm={this.paymentDialogConfirm}
                               open={this.state.paymentDialogOpen}>
                    <Row>
                    <Col xs={12} style={{marginTop: 15}}>
                        <TextInput field={{
                                       name: 'BuyPages',
                                       value: this.state.buyPagesValue,
                                       onChange: (evt) => {
                                            this.setState({buyPagesValue: evt.target.value});
                                       }
                                   }}
                                   label='Pages To Purchase'/>
                    </Col>
                    </Row>
                    <Row>
                    <Col xs={12}>
                        <StaticField label='Cost (without tax)' value={`$${buyPagesCost}`}/>
                    </Col>
                    </Row>
                </ConfirmDialog>
                {!showAsDialog && (
                <Row style={{float: 'right'}}>
                    <Col xs={12}>
                    {sendFaxesBtn}
                    </Col>
                </Row>)}
                </div>)}
                {renderFaxesSentComponent && (
                <div>
                <Row>
                    <Col xs={12}>
                        <FormField loading={loading} label='Sent Faxes'/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} style={{height: '290px'}}>
                        <Table headers={headers}
                               rows={rows}
                               height={270}
                               downloadRow={this.downloadFaxRow}/>
                    </Col>
                </Row>
                </div>)}
            </div>
        );

        if (showAsDialog) {
            result = (
            <Modal show={dialogOpen}
                   backdrop='static'
                   onHide={dialogCancel}
                   dialogClassName="modal-dialog-tall">
               <Modal.Header closeButton style={{ backgroundColor: dialogHeaderFooterBgColor }}>
                   <Modal.Title>Send Fax</Modal.Title>
               </Modal.Header>
               <Modal.Body>
               <Row>
                   <Col xs={12}>
                    {result}
                   </Col>
               </Row>
               </Modal.Body>
               <Modal.Footer style={{ backgroundColor: dialogHeaderFooterBgColor }}>{sendFaxesBtn}</Modal.Footer>
            </Modal>);
        }

        return result;
    }
}

FaxForm.propTypes = {
    beforeFaxSending: PropTypes.func,
    attachments: PropTypes.array.isRequired,
    disabled: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    renderFaxesSentComponent: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => {
    let config = state.user.config;
    let currentCase = state.cases.current;
    let recipients = extractFieldsOptions(config, currentCase, 'Fax');

    return {
        currentCase,
        config,
        billing: state.user.billing,
        recipients,
        loggedIn: state.user.loggedIn
    }
};

export default connect(mapStateToProps)(FaxForm);
